import React, { useState } from "react";
import styles from "./PreviewBlogTab.module.scss";
import SelectABlogPost from "../SelectABlogPost/SelectABlogPost";
import BlogPost from "../../../BlogTab/BlogPostPage/BlogPost";
import axiosInstance from "../../../../../util/AxiosInstance/AxiosInstance";
import MessageComponent from "../../../../../Components/MessageComponent/MessageComponent";

const PreviewBlogTab = () => {
  const [message, setMessage] = useState("");
  const [selectedPost, setSelectedPost] = useState(null);

  const handlePostSelect = (post) => {
    if (!post) return;
    setSelectedPost(post);
  };

  const handlePublish = async () => {
    if (!selectedPost) {
      setMessage("Please select a post to publish");
      return;
    }

    try {
      const response = await axiosInstance.post('/admin/publishBlogPost', {
        postId: selectedPost._id
      });

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to publish post");
      }

      setMessage("Post published successfully!");
      setSelectedPost(null);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className={styles.tabContent}>
      <div className={styles.stagingHeader}>
        <h2>Staging</h2>
        <p>Select a staged post to preview and publish.</p>
      </div>
      <MessageComponent message={message}/>

      <div className={styles.selectContainer}>
      <SelectABlogPost onPostSelect={handlePostSelect} />
      </div>

      {selectedPost && (
        <>
          <div className={styles.previewContainer}>
        <BlogPost key={selectedPost._id} post={selectedPost} />
          </div>
          <div className={styles.publishButtonContainer}>
            <button 
              className={styles.publishButton}
              onClick={handlePublish}
            >
              Publish Post
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default PreviewBlogTab;
